import { Reveal, SectionHead } from "./shared";
import { IMAGES, SAFETY_PILLARS } from "../data/content";

export const Safety = () => (
    <section id="safety" data-testid="safety-section" className="relative bg-white py-16 lg:py-32">
        <div className="vec-container">
            <div className="grid grid-cols-12 gap-y-8 lg:gap-x-14 items-start">
                <div className="col-span-12 lg:col-span-5 lg:sticky lg:top-28">
                    <SectionHead
                        index="SEC 09"
                        eyebrow="Safety & Quality"
                        title="Safety. Quality. Responsibility."
                    />
                    <Reveal delay={0.2}>
                        <p className="mt-5 text-base sm:text-lg leading-relaxed text-vec-charcoal/70">
                            Power infrastructure demands discipline. Every VEC site operates with
                            safety-conscious planning, structured execution and accountable
                            workmanship — because the infrastructure we build carries responsibility.
                        </p>
                    </Reveal>
                    <Reveal delay={0.28}>
                        <div className="group tech-frame relative mt-7 overflow-hidden border border-vec-border aspect-[4/3]">
                            <img
                                src={IMAGES.safety}
                                alt="Safety helmet, protective glasses and gloves at a VEC substation at sunset"
                                loading="lazy"
                                className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                            />
                            <span className="absolute bottom-3 left-3 bg-vec-charcoal/85 text-white font-mono-tech text-[9px] uppercase tracking-[0.2em] px-3 py-1.5">
                                Fig. 04 — Disciplined Site Practice
                            </span>
                        </div>
                    </Reveal>
                </div>

                <div className="col-span-12 lg:col-span-7 border-t border-vec-border lg:self-center">
                    {SAFETY_PILLARS.map((p, i) => (
                        <Reveal key={p.num} delay={i * 0.08}>
                            <div
                                data-testid={`safety-pillar-${p.num}`}
                                className="group grid grid-cols-12 gap-4 items-baseline py-8 lg:py-10 border-b border-vec-border hover:bg-vec-mist/70 transition-colors duration-300 px-2 sm:px-4"
                            >
                                <span className="col-span-2 sm:col-span-1 font-display text-3xl sm:text-4xl font-bold text-vec-green/25 group-hover:text-vec-green transition-colors duration-300">
                                    {p.num}
                                </span>
                                <h3 className="col-span-10 sm:col-span-4 font-display text-lg sm:text-2xl font-semibold uppercase tracking-tight text-vec-charcoal">
                                    {p.title}
                                </h3>
                                <p className="col-span-12 sm:col-span-7 text-sm sm:text-base leading-relaxed text-vec-charcoal/65">
                                    {p.description}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </div>
    </section>
);
